import { render } from "./RummikubGame.vue?vue&type=template&id=28c3d184&scoped=true"
import script from "./RummikubGame.vue?vue&type=script&lang=js"
export * from "./RummikubGame.vue?vue&type=script&lang=js"

import "./RummikubGame.vue?vue&type=style&index=0&id=28c3d184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c3d184"]])

export default __exports__